import { getUser } from "../../utilis/Common";

export const CMS_PRIMARY = "#007BFF";
export const CMS_PRIMARY_HOVER = "#0069D9";
export const CMS_PRIMARY_LIGHT = "rgba(0, 123, 255, 0.1)";

/** Shared inner padding for task management pages */
export const TASK_PAGE_SHELL_CLASS = "px-2 pb-8 sm:px-3";

/** Top spacing below page Title header — keeps header distinct from stats/content */
export const MODULE_PAGE_SHELL_STYLE = {
  paddingTop: "20px",
};

export const STATUS_OPTIONS = [
  "Pending",
  "In Progress",
  "On Hold",
  "Completed",
  "Cancelled",
];

export const PRIORITY_OPTIONS = ["Low", "Medium", "High", "Critical"];

export const STATUS_STYLES = {
  Pending: "bg-yellow-100 text-yellow-800 border border-yellow-300",
  "In Progress": "bg-blue-100 text-blue-800 border border-blue-300",
  "On Hold": "bg-orange-100 text-orange-800 border border-orange-300",
  Completed: "bg-green-100 text-green-800 border border-green-300",
  Cancelled: "bg-red-300 text-red-950 border border-red-400",
};

export const STATUS_ACCENT = {
  Pending: "#eab308",
  "In Progress": "#3b82f6",
  "On Hold": "#f97316",
  Completed: "#22c55e",
  Cancelled: "#ef4444",
};

export const STATUS_HEADER_BG = {
  Pending: "rgba(234, 179, 8, 0.1)",
  "In Progress": "rgba(59, 130, 246, 0.1)",
  "On Hold": "rgba(249, 115, 22, 0.1)",
  Completed: "rgba(34, 197, 94, 0.1)",
  Cancelled: "rgba(239, 68, 68, 0.1)",
};

export const PRIORITY_STYLES = {
  Low: "bg-slate-100 text-slate-600 border border-slate-300",
  Medium: "bg-blue-100 text-blue-700 border border-blue-300",
  High: "bg-orange-500 text-white border border-orange-600 font-bold",
  Critical: "bg-red-600 text-white border border-red-700 font-bold",
};

export const getCurrentUserMeta = () => {
  const user = getUser();
  return {
    created_by: user?.id || null,
    created_by_name: user?.name || "Unknown User",
  };
};

export const EMPTY_WORKSPACE = {
  title: "",
  description: "",
  status: "Pending",
  priority: "Medium",
  start_date: "",
  due_date: "",
};

/** @deprecated use EMPTY_WORKSPACE */
export const EMPTY_WORKPLACE = EMPTY_WORKSPACE;

export const formatDate = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
